<template>
  <div>
    <Tabs value="name1">
      <TabPane label="智能安全教育体验区" name="name1">
        <SafetyEducation></SafetyEducation>
      </TabPane>
      <TabPane label="安全教育体验区(室外版)" name="name2">
        <Experience></Experience>
      </TabPane>
      <TabPane label="工法质量样板展示区" name="name3">
        <Row justify="start" type="flex">
          <Col
            class="buy_col01"
            v-for="(item, index) in photoArr1"
            :key="index"
          >
            <div class="buy_rule" @click="getMoney(item)">
              <img :src="item.photoUrl" alt="#" />
            </div>
            <div @click="getMoney(item)" class="sp">{{ item.ref }}</div>
            <div style="font-size: 18px; color: #f12344; margin-bottom: 6px">
              <!--{{item.money}}-->
              <Button type="primary" @click="getMoney(item)">了解更多</Button>
              <!-- <Button type="primary" @click="getMoney01(item)">立即购买</Button> -->
            </div>
          </Col>
        </Row>
      </TabPane>
    </Tabs>
    <!--对话框-->
    <div>
      <Modal
        class="modal_div"
        v-model="modal1"
        width="830px"
        class-name="vertical-center-modal"
        @on-visible-change="onChange"
      >
        <div slot="header">
          <Row>
            <Col span="20">
              <span class="header_div">{{ this.ref }}</span>
            </Col>
          </Row>
        </div>
        <div class="wid_img">
          <div>
            <img :src="item01.photoUrl" alt="暂无图片" />
          </div>
          <div class="Introduction">
            <!-- <div class="">
              价 格: <span style="color: #1966ff"> {{ item01.money }}</span>
            </div> -->
            <div class="Introduction__p">介 绍：{{ item01.p }}</div>
            <div class="phone">
              咨询电话: <span style="color: #1966ff"> 18001306738</span>
            </div>
          </div>
        </div>
        <div slot="footer">
          <Button @click="modal1 = false">取消</Button>
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
import ThreeDimensional from "./ThreeDimensional.vue";
import SafetyEducation from "./SafetyEducation.vue";
import Experience from "./Experience.vue";
export default {
  components: {
    Experience,
    ThreeDimensional,
    SafetyEducation,
  },
  data() {
    return {
      modal1: false,
      profile: "",
      item01: [],
      ref: "",
      VRImg: [],
      photoArr1: [
        // 建筑施工工程梁柱节点质量样板
        {
          photoUrl: "../../../static/img/photo/photo_quality.jpg",
          dimension: "2.3*2.8m",
          p: "材质及做法：钢筋设置、钢筋绑扎、框架柱砼、柱支模等工艺",
          ref: "建筑施工工程梁柱节点质量样板",
          money: "¥13000.00",
        },
        // 独立柱质量样板
        {
          photoUrl: "../../../static/img/photo/photo_detached.jpg",
          dimension: "2.3*2.8m",
          p: "材质及做法：钢筋设置、钢筋绑扎、框架柱砼、柱支模等工艺。",
          ref: "独立柱质量样板",
          money: "¥13000.00",
        },
        // 剪力墙质量样板
        {
          photoUrl: "../../../static/img/photo/photo_shear.jpg",
          dimension: "2.3*2.8m",
          p: "材质及做法：后浇带，钢筋，支模，砼浇筑",
          ref: "剪力墙质量样板",
          money: "¥13000.00",
        },
        // 电气预埋质量样板
        {
          photoUrl: "../../../static/img/photo/photo_electrical.jpg",
          dimension: "2.3*2.8m",
          p: "材质及做法：机械开槽，甩浆挂网，混凝土填塞，开关插座预埋，开关箱，等电位，多媒体集线箱预埋等工艺",
          ref: "电气预埋质量样板",
          money: "¥13000.00",
        },
        // 同层排水质量样板
        {
          photoUrl: "../../../static/img/photo/photo_drain.png",
          dimension: "2.3*2.8m",
          p: "材质及做法：给水管安装，给水口留设，排水立管、排水支管安装，排水口留设，积水器安装，卫生间防水做法等工艺",
          VRImg: ["../../../static/img/photo-da/photo_drain.png"],
          ref: "同层排水质量样板",
          money: "¥13000.00",
        },
        // 屋面样板
        {
          photoUrl: "../../../static/img/photo/photo_roof.png",
          dimension: "2.3*2.8m",
          p: "材质及做法：天沟，斜坡，屋面地面分层，防水保温",
          ref: "屋面样板",
          money: "¥13000.00",
        },
        // 楼梯样板
        {
          photoUrl: "../../../static/img/photo/photo_stairs.jpg",
          dimension: "2.3*2.8m",
          p: "材质及做法：钢筋，支模，混凝土浇筑",
          ref: "楼梯样板",
          money: "¥13000.00",
        },
        // 砌体抹灰样板
        {
          photoUrl: "../../../static/img/photo/photo_brickwork.jpg",
          dimension: "2.3*2.8m",
          p: "材质及做法：门窗洞口，砌体粉饰，保温，电气预埋",
          ref: "砌体抹灰样板",
          money: "¥13000.00",
        },
      ],
    };
  },

  methods: {
    onChange() {
      document
        .querySelector("body")
        .setAttribute("style", "overflow:hidden;padding-right:15px");
    },
    /*弹出对话框*/
    getMoney(item) {
      this.VRImg = item.VRImg;
      this.modal1 = true;
      this.item01 = item;
      this.ref = item.ref;
      this.profile = item.p;
    },
    /*刚进页面的立即购买*/
    getMoney01(item) {
      this.goBuy(item);
    },
    /*弹出框里面立即购买*/
    goBuyGo() {
      this.modal1 = false;
      this.goBuy(this.item01);
      document.querySelector("body").setAttribute("style", "overflow:auto");
    },
    /*购买*/
    goBuy(item) {
      sessionStorage.setItem("title", item.title);
      sessionStorage.setItem("belong", item.belong);
      sessionStorage.setItem("path", item.path);
      sessionStorage.setItem("money", item.money);
      sessionStorage.setItem("ref", item.ref);
      sessionStorage.setItem("photoUrl1", item.photoUrl1);
      sessionStorage.setItem("classify", JSON.stringify(item.classify));
      this.$router.push({
        path: "/home/buyGo",
      });
    },
  },
};
</script>
<style>
.modal_div .ivu-modal-header p,
.modal_div .ivu-modal-header-inner {
  color: #02a0e7;
  font-size: 20px;
  font-weight: bold;
  font-family: 新宋体, serif;
}

/*面包屑*/
.col_bread .ivu-breadcrumb {
  font-size: 16px;
}
</style>
<style scoped>
/*弹出框字体*/
.header_div {
  color: #02a0e7;
  font-size: 20px;
  font-weight: bold;
  font-family: 新宋体, serif;
}

.font_size {
  font-size: 19px;
  white-space: pre-wrap;
}

.buy_col01 {
  width: 270px;
  background: #ffff;
  text-align: center;
  cursor: pointer;
  margin: 14px 0px 0 22px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
}

.buy_col01:hover {
  box-shadow: 0 0 3px 3px rgba(0, 0, 0, 0.2);
}

.buy_col01 .sp:hover {
  color: red;
}

.buy_rule {
  width: 270px;
  height: 240px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.buy_rule img {
  width: 210px;
  height: 210px;
}

.sp {
  font-size: 14px;
  height: 40px;
}

.wid_img {
  display: flex;
  align-items: center;
}

.wid_img img {
  width: 364px;
  height: 263px;
}

.Introduction {
  width: 364px;
  height: 263px;
  margin-left: 15px;
}

.Introduction__p {
  margin-top: 15px;
}

.buy_rule img:hover {
  animation: move 0.5s linear forwards;
}

@keyframes move {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(1.1);
  }
}

.phone {
  margin-top: 5%;
}
</style>



// WEBPACK FOOTER //
// src/components/Buy/Quality.vue